import Firebase from '../../../firebase';
import { CASES_COLLECTION } from '../../../firebase/collections';

const collection = Firebase.db.collection(CASES_COLLECTION);

export const requestSetPMCFStage = async ({ id, ...restProps }) => {
  return await collection.doc(id).update({ ...restProps });
};
